import React, { useEffect } from 'react';
import styles from './Filter.module.scss';

import DialogWrapper from 'components/DialogComponents/DialogWrapper';
import { FormDayPicker, FormLabel } from 'components/FormComponents';
import { FilterActions, FilterHeader } from 'components/FilterComponentsV2';
import FormMultiSelect from 'components/FormComponents/FormMultiSelect/FormMultiSelect';

import { FormProvider, useForm } from 'react-hook-form';
import { useMobileViewport } from 'hooks/useMobileViewport';

import { defaultFilter } from '../helpers';

export function Filter({ open, setOpen, onApply, filter, filterCriteria }) {
  const isMobile = useMobileViewport();

  const methods = useForm({
    defaultValues: { ...defaultFilter },
    mode: 'onChange'
  });
  const { getValues, reset, setValue, watch } = methods;

  const { priorities, severities, statuses } = filterCriteria;

  useEffect(() => {
    if (open) {
      reset(filter.filters);
    }
  }, [open]);

  const closePopup = () => setOpen(false);

  const applyFilter = () => {
    onApply(getValues());
    closePopup();
  };

  const clearFilter = () => {
    const defaultState = { ...defaultFilter.filters, searchQuery: getValues('searchQuery') };
    reset(defaultState);
  };

  const handleMultiSelect = (name, value) => setValue(name, value);

  const openedFromWatcher = watch('openedFrom');
  const openedToWatcher = watch('openedTo');
  const resolvedFromWatcher = watch('resolvedFrom');
  const resolvedToWatcher = watch('resolvedTo');

  return (
    <DialogWrapper open={open} onClose={closePopup}>
      <div className={styles.dialog}>
        {isMobile && <FilterHeader title="Filters" onBack={closePopup} />}
        <FormProvider {...methods}>
          <div className={styles.form}>
            <div className={styles.form__block}>
              <div className={styles.form__block_cell}>
                <FormLabel>Status</FormLabel>
                <FormMultiSelect
                  trackById
                  name="statusIds"
                  options={statuses || []}
                  onSelect={handleMultiSelect}
                />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Priority</FormLabel>
                <FormMultiSelect
                  trackById
                  name="priorityIds"
                  options={priorities || []}
                  onSelect={handleMultiSelect}
                />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Severity</FormLabel>
                <FormMultiSelect
                  trackById
                  name="severityIds"
                  options={severities || []}
                  onSelect={handleMultiSelect}
                />
              </div>
            </div>
            <div className={styles.form__block}>
              <div className={styles.form__block_cell}>
                <FormLabel>Opened from</FormLabel>
                <FormDayPicker name="openedFrom" max={openedToWatcher || new Date()} />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Opened to</FormLabel>
                <FormDayPicker name="openedTo" min={openedFromWatcher} max={new Date()} />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Resolved from</FormLabel>
                <FormDayPicker name="resolvedFrom" max={resolvedToWatcher || new Date()} />
              </div>
              <div className={styles.form__block_cell}>
                <FormLabel>Resolved to</FormLabel>
                <FormDayPicker name="resolvedTo" min={resolvedFromWatcher} max={new Date()} />
              </div>
            </div>
          </div>
        </FormProvider>
        <FilterActions onClear={clearFilter} onCancel={closePopup} onApply={applyFilter} />
      </div>
    </DialogWrapper>
  );
}
